module.exports = __webpack_public_path__ + "img/67_17.91a2f0e0.png";